import React from "react"
import createReactClass from "create-react-class"
import cx from "classnames"
import {validateDatePicker, hasDateErrors} from "auth/business/date-picker"
import * as shared from "auth/component/shared"
import range from "array-range"
import {SelectAccessible, ErrorMessage} from "../../components/inputs"
import {PrimaryButton} from "../../components/buttons"

const newBirthdate = (month, day, year) => ({month, day, year})

const leadZero = (n) => (parseInt(n, 10) < 10 ? `0${n}` : n.toString())

const calculateBirthdate = (age) => {
  if (age && age > 0) {
    const today = new Date()
    return newBirthdate(leadZero(today.getMonth() + 1), leadZero(today.getDate()), (today.getFullYear() - age).toString())
  } else {
    return newBirthdate()
  }
}

export default createReactClass({
  getInitialState() {
    return {
      ...newBirthdate(),
      submitAttempted: false,
      validationErrors: {}
    }
  },
  handleAgeChange({target}) {
    this.setState({
      ...calculateBirthdate(target.value),
      validationErrors: {} // Clear errors when user makes selection
    })
  },
  handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault()
      this.onContinue(this.props.onContinue, e)
    }
  },
  onContinue(onContinueFn, e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({submitAttempted: true})

    if (this.hasErrors()) {
      this.showValidationErrors()
      return
    }

    onContinueFn(`${this.state.year}-${this.state.month}-${this.state.day}`)
  },
  showValidationErrors() {
    const validationErrors = {}

    if (this.hasErrors()) {
      validationErrors.age = "Please select your age to continue."
    }

    this.setState({validationErrors})
  },
  hasErrors() {
    return hasDateErrors(validateDatePicker(this.state))
  },
  render() {
    const hasErrors = this.hasErrors()
    return (
      <shared.Subscreen>
        <shared.Textbox>
          <shared.H2>How old are you?</shared.H2>
          <shared.Explanation>Providing your age helps you get the right experience with Banzai and protects your privacy.</shared.Explanation>
        </shared.Textbox>
        <div className="grid gap-y-10">
          <div>
            <SelectAccessible
              id="age-select"
              hideLabel={true}
              label="Select Your Age"
              onChange={this.handleAgeChange}
              onKeyDown={this.handleKeyDown}
              aria-invalid={this.state.validationErrors.age ? "true" : "false"}
              aria-describedby={this.state.validationErrors.age ? "age-error" : undefined}
            >
              <option value="">Select your age...</option>
              {range(5, 101).map((v) => (
                <option key={v}>{v}</option>
              ))}
            </SelectAccessible>
            {this.state.validationErrors.age && <ErrorMessage id="age-error">{this.state.validationErrors.age}</ErrorMessage>}
          </div>

          <PrimaryButton onClick={this.onContinue.bind(null, this.props.onContinue)} className={cx("continue-button")}>
            Continue
          </PrimaryButton>
        </div>
      </shared.Subscreen>
    )
  }
})
